/* <recently-viewed>: remembers viewed product ids and renders them with the theme's own cards
   via the search page + Section Rendering API. Nothing is fetched until the section nears the viewport. */
(() => {
  const KEY = 'tt_recent_ids', MAX = 16;
  const read = () => { try { return (JSON.parse(localStorage.getItem(KEY) || '[]') || []).map(String).filter(x => /^\d+$/.test(x)); } catch (e) { return []; } };
  window.ttRecent = window.ttRecent || {
    read,
    add(id) {
      id = String(id || ''); if (!/^\d+$/.test(id)) return;
      try { localStorage.setItem(KEY, JSON.stringify([id, ...read().filter(x => x !== id)].slice(0, MAX))); } catch (e) {}
    }
  };
  // Record the product being viewed
  const pdp = document.getElementById('PdpPage');
  if (pdp && pdp.dataset.productId) window.ttRecent.add(pdp.dataset.productId);

  if (customElements.get('recently-viewed')) return;
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  customElements.define('recently-viewed', class extends HTMLElement {
    connectedCallback() {
      if (this.querySelector('.ct__item')) { this.hidden = false; return; } // theme editor preview
      const exclude = this.dataset.exclude || '';
      const ids = read().filter(id => id !== exclude).slice(0, parseInt(this.dataset.limit) || 8);
      if (!ids.length) return; // nothing viewed yet: stay hidden
      const load = async () => {
        try {
          const q = ids.map(id => 'id:' + id).join(' OR ');
          const url = `${root}search?q=${encodeURIComponent(q)}&type=product&options[unavailable_products]=last&section_id=${encodeURIComponent(this.dataset.section)}`;
          const html = await (await fetch(url)).text();
          const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('recently-viewed');
          const items = fresh ? [...fresh.querySelectorAll('[data-rv-id]')] : [];
          if (!items.length) return;
          // Search returns relevance order; put them back in viewing order (latest first)
          const byId = new Map(items.map(el => [el.dataset.rvId, el]));
          const track = fresh.querySelector('[data-ct-track]');
          track.textContent = '';
          ids.forEach(id => { const el = byId.get(id); if (el) track.appendChild(el); });
          this.innerHTML = fresh.innerHTML;
          this.hidden = false;
          window._wishlist?._updateAllBtns?.();
        } catch (e) { /* stay hidden */ }
      };
      const target = this.closest('.shopify-section') || this.parentElement;
      if (!('IntersectionObserver' in window) || !target) { load(); return; }
      const io = new IntersectionObserver(es => { if (es.some(e => e.isIntersecting)) { io.disconnect(); load(); } }, { rootMargin: '400px' });
      io.observe(target);
    }
  });
})();
